import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router, Params,
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';

@Component({
  selector: 'app-mainmenu',
  templateUrl: './mainmenu.component.html',
  styleUrls: ['./mainmenu.component.css']
})
export class MainmenuComponent implements OnInit {
  timer: any;
  counter = 1;
  loading: any;
  constructor() {
    if (document.getElementById('js1')) {
      document.getElementById('js1').remove();
      const js1 = document.createElement('script');
      js1.setAttribute('id', 'js1');
      js1.setAttribute('src', './assets/js/jquery-3.2.1.min.js');
      document.body.appendChild(js1);
    }
    if (document.getElementById('js2')) {
    document.getElementById('js2').remove();
    const js2 = document.createElement('script');
    js2.setAttribute('id', 'js2');
    js2.setAttribute('src', './assets/js/webslidemenu.js');
    document.body.appendChild(js2);
    }
   }

  ngOnInit() {
    var headerfull = document.getElementById("wmsticky");
    var sticylogo = document.getElementById("sticylogo2");
    var menubg = document.getElementById("menub");
    var stickyalign = document.getElementById("sticky3");
    var sticky = headerfull.offsetTop;

    window.onscroll = function() {myFunction()};

  function myFunction() {

  if (window.pageYOffset >= sticky) {
    headerfull.classList.add("sticky");
    sticylogo.classList.add("sticky2");
    stickyalign.classList.add("stickyalign2");
  } else {
    headerfull.classList.remove("sticky");
    sticylogo.classList.remove("sticky2");
        stickyalign.classList.remove("stickyalign2");
  }
  }
  }

  togglenav() {
        var x = document.getElementById("hidenav");
        var y = document.getElementById("hidenav2");
        if (x.style.display === "none") {
            x.style.display = "block";
        } else {
            x.style.display = "none";
        }

        if (y.style.display === "none") {
            y.style.display = "block";
        } else {
            y.style.display = "none";
        }
    }



    navigationInterceptor(event: RouterEvent): void {

      if (event instanceof NavigationStart) {
        this.togglenav();
        this.counter = 1;
        this.timer = setInterval(() => this.timedelay(), 1000);

      }
    }

    timedelay() {
      this.counter = this.counter  - 1;
      if (this.counter == 0) {
        clearInterval(this.timer);
        this.togglenav();
      }

    }

}
